import {createApp} from 'vue'
import App from './App.vue'
import { router } from './router'
import { i18n } from './i18n'
import Toast from "vue-toastification";
import { RouterLink } from 'vue-router';

import ODS from '@/ods/index.ts';

import "vue-toastification/dist/index.css";

import 'omind-design-system/assets/styles/all.scss'
import './assets/styles/style.css'
import './assets/styles/ods-style.scss'
import './assets/styles/responsive.scss'
import { isInLocalDevelopmentMode } from '@/functions/development';
import axios from 'axios';

const toastOptions = {
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false,
  transition: "Vue-Toastification__fade",
  maxToasts: 20,
  newestOnTop: true
}

const app = createApp(App)

if (import.meta.env.VITE_ICONS_URL) {
  app.provide('odsIconPath', import.meta.env.VITE_ICONS_URL)
}
app.provide('RouterLinkComponent', RouterLink)

app.use(router)
app.use(i18n)
app.use(Toast, toastOptions)
//@ts-ignore
app.use(ODS)
//app.use(useODSPlugin);

app.mount('#app');

